var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDragCursor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 18,
    rx: 9,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 18,
    rx: 9,
    stroke: "#EEEFF2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4338 14.0433C10.7574 14.3669 11.2821 14.3669 11.6056 14.0433C11.9292 13.7197 11.9292 13.1951 11.6056 12.8715L8.87715 10.143L11.6056 7.41451C11.9292 7.09092 11.9292 6.56628 11.6056 6.24269C11.2821 5.9191 10.7574 5.9191 10.4338 6.24269L7.41238 9.26414C6.92699 9.74953 6.92699 10.5365 7.41238 11.0219L10.4338 14.0433Z",
    fill: "#231052"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.316 10.143L16.5874 12.8716C16.2638 13.1951 16.2638 13.7198 16.5874 14.0434C16.911 14.3669 17.4357 14.3669 17.7592 14.0434L20.7807 11.0219C21.2661 10.5365 21.2661 9.74955 20.7807 9.26416L17.7592 6.24269C17.4357 5.9191 16.911 5.9191 16.5874 6.24269C16.2638 6.56629 16.2638 7.09093 16.5874 7.41452L19.316 10.143Z",
    fill: "#231052"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragCursor);
export default __webpack_public_path__ + "static/media/drag-cursor.d4f71e91c3098d86b5ecece8f53f28d8.svg";
export { ForwardRef as ReactComponent };